/* This renders a horizontal card, for either Michigan or OSU
   with the text left aligned

   Hassaan Ali Wattoo 
*/ 

import React from 'react';
import ReadArticleButton from '../readArticleButton.jsx';

class LeftCard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            year: this.props.year, 
            headline: this.props.headline,
            authorName: this.props.authorName,
            authorPosition: this.props.authorPosition,
            logo: this.props.logo,
            isColor: this.props.isColor,
            theme: this.props.theme,
        }
    }

    render() {
        return (
            <div className={`left-article-card row article`} id={this.props.id} >
                <div className={`article-text seven columns ${this.state.isColor === false ? 'black' : ''} ${this.state.theme === 'maize' ? 'maize' : 'ohio'}`}>
                    <div className='article-year'>{this.state.year}</div>
                    <div className='article-headline'>{this.state.headline}</div>
                    <div className='article-author'>
                        <b>{this.state.authorName}</b> {this.state.authorPosition}
                    </div>
                    <ReadArticleButton url={this.props.url} theme={this.state.isColor ? this.state.theme : "mblue"}/>
                    <div className='news-logo'>
                        <img
                        src={this.state.logo}
                        alt="Newspaper Logo"
                        />
                    </div>
                </div>
            </div>
        );
    }
        
    
}

export default LeftCard;